"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Provide with helpful JSON utility functions.
 */
var JsonUtility = /*#__PURE__*/function () {
  function JsonUtility() {
    _classCallCheck(this, JsonUtility);
  }

  _createClass(JsonUtility, null, [{
    key: "toSortedJson",

    /**
     * Converts an object to sorted JSON.
     *
     * @param {object} object Object.
     * @returns {string} Sorted JSON.
     */
    value: function toSortedJson(object) {
      var _this = this;

      if (_typeof(object) === 'object') {
        return '{' + Object.keys(object).sort().map(function (key) {
          return '"' + key + '":' + _this.toSortedJson(object[key]);
        }).join(',') + '}';
      }

      return JSON.stringify(object);
    }
  }]);

  return JsonUtility;
}();

exports.default = JsonUtility;